import { type GetBalanceResponseDTO, useIntl } from '@capsicum/common';
import { convertNcwBalanceCurrencies, usePartners } from '@capsicum/socios-core';

export const useNCWPartnerDetails = (tokenShortCode?: string, ncwBalance?: GetBalanceResponseDTO) => {
	const { $t } = useIntl();
	const { getPartnerBy } = usePartners();

	// TODO: to remove this conversion when BE returns currencies as a Array
	const currenciesArray = convertNcwBalanceCurrencies(ncwBalance?.currencies);
	const currencyId = currenciesArray.find(c => c.currency.shortCode === tokenShortCode)?.currency.id;

	const partnerId = getPartnerBy(p => p.currencyId === currencyId)?.id;

	return {
		currencyId,
		intlText: {
			pageTitle: $t('ncWallet.partnerDetails.pageTitle', { partnerShortCode: tokenShortCode })
		},
		partnerId
	};
};
